import BaseCom from "../BaseCom";
import Icon from "../Icon";

export default class ConfirmButton extends BaseCom {
    render() {
        return (
            <button className="btn btn-lg btn-primary d-block" type={this.props.submit ? 'submit' : 'button'} onClick={this.props.onClick} disabled={this.props.disabled}>
                {this.props.icon} {this.props.children || this.props.label || "Confirm"}
            </button>
        );
    }
}